"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _icons = require("@jsluna/icons");

var _card = require("@jsluna/card");

var _constants = require("../utils/constants");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Message = function Message(_ref) {
  var iconName = _ref.iconName,
      messages = _ref.messages;
  var iconStyle = {
    height: 40,
    width: 40,
    marginBottom: 2
  };

  var iconElement = /*#__PURE__*/_react.default.createElement(_icons.InfoCircle, {
    color: "#428FDA",
    style: iconStyle
  });

  switch (iconName) {
    case _constants.ICONS.INFO_CIRCLE:
      iconElement = /*#__PURE__*/_react.default.createElement(_icons.InfoCircle, {
        color: "#428FDA",
        style: iconStyle
      });
      break;

    case _constants.ICONS.ERROR_CIRCLE:
      iconElement = /*#__PURE__*/_react.default.createElement(_icons.ErrorCircle, {
        color: "#BD0000",
        style: iconStyle
      });
      break;
  }

  return /*#__PURE__*/_react.default.createElement(_card.Card, {
    className: "ln-u-flush ln-u-margin-bottom*2 ln-u-margin-top*3 ln-u-text-align-center"
  }, iconElement, messages.map(function (message, index) {
    return message && /*#__PURE__*/_react.default.createElement("h6", {
      key: index,
      className: "ln-u-flush ln-c-label ln-u-display-block"
    }, message);
  }));
};

Message.propTypes = {
  /** The name of the supported luna icon */
  iconName: _propTypes.default.string.isRequired,

  /** Message to be displayed under the icon */
  messages: _propTypes.default.arrayOf(_propTypes.string).isRequired
};
Message.defaultProps = {
  iconName: '',
  messages: []
};
var _default = Message;
exports.default = _default;